import { Component, ContentChild, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { environment } from 'src/environments/environment.prod';
import { ApisService } from '../../shared/services/api.service';

@Component({
  selector: 'app-section-booking',
  templateUrl: './section-booking.component.html',
  styleUrls: ['./section-booking.component.scss']
})
export class SectionBookingComponent implements OnInit {
  @ViewChild('content') content: ElementRef;

  first_name: any = '';
  last_name: any = '';
  email: any = '';
  phone: any = '';
  vcode: any = '';
  seat: any = '';
  address: any = '';
  remarks: any = '';

  message: any = '';
  greeting: any = '';

  notif: any = '';

  constructor(
    private api: ApisService,
    private config: NgbModalConfig,
    private modal: NgbModal,
    //private loader: LoaderComponent
  ) { 
    config.backdrop = 'static';
		config.keyboard = false;
  }

  ngOnInit() {
  }

  showGreeting(message: any) {
    this.notif = message;
    this.modal.open(this.content, {centered: true});
  }

  showWarning(message: any) {
    this.notif = message;
    this.modal.open(this.content, {centered: true});
  }

  group: any = 'select';
  setGroup(pick) {
    this.group = pick;
  }

  reserveSeat(content) {
    //this.loader.show = true;

    if (!this.first_name || !this.last_name || !this.email || !this.phone || !this.seat || !this.group || this.group == 'select') {
      this.showWarning('All non-optional fields are required');
      return false;
    }

    const emailfilter = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailfilter.test(this.email)) {
      this.showWarning('Please enter valid email, thank you!');
      return false;
    }

    //Prepare user object.
    let user = {
      event_id: 3,
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      phone: this.phone,
      vcode: this.vcode,
      seat: this.seat,
      address: this.address,
      group: this.group,
      remarks: this.remarks
    };

    //submit to server
    this.api.posts('/v1/api/EventPass/reserve', user).then((res: any) => {
      if(res && res.success === true && res.data) {
        if(!res.data.existing) {
          this.showGreeting( 'Your ticket pass reservation is now being process. Ref# '+res.data.uuid+'. Please check your email for more info about your seat reservation.');
        } else {
          this.showGreeting( 'Your ticket pass is already being process. Ref# '+res.data.uuid+'. Please check your email for more info about your seat reservation.');
        }
        this.first_name = '';
        this.last_name = '';
        this.email = '';
        this.phone = '';
        this.vcode = '';
        this.seat = '';
        this.address = '';
        this.group = 'select';
        this.remarks = '';
      } else {
        this.showWarning(res.message);
      }

    }).catch(error => {
      this.showWarning('Something went wrong, contact technical support.');
      console.log('error', error);
    });
  }

}
